import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import FeaturedVideoSection from "@/components/FeaturedVideoSection";
import AboutSection from "@/components/AboutSection";
import CurrentProjectsSection from "@/components/CurrentProjectsSection";
import WatchesSection from "@/components/WatchesSection";
import SocialsSection from "@/components/SocialsSection";
import BuildServiceSection from "@/components/BuildServiceSection";
import ContactSection from "@/components/ContactSection";
import WorkshopInfoSection from "@/components/WorkshopInfoSection";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <FeaturedVideoSection />
      <AboutSection />
      <CurrentProjectsSection />
      <WatchesSection />
      <SocialsSection />
      <BuildServiceSection />
      <Footer />
    </div>
  );
};

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <ContactSection />
      <Footer />
    </div>
  );
};

const WorkshopInfoPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WorkshopInfoSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/workshop-info" element={<WorkshopInfoPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
